<template>
    <!-- 顶部信息区域  -->
    <div :class="{'daily-product':true,'inteproduct':type == 19,'raderproduct':type == 20}">
        <div :class="{'inte-back':true,'not-inte':type != 19 && type != 20}"></div>
        <div class="daily-desc">{{dailyMap[type + '']}}介绍：{{info.description}}</div>
        <template v-if="type == 19">
            <div class="intelligence-card">
                <div class="card">
                    <p class="cardicon"><i class="inte-core"></i></p>
                    <p class="cardname">核心机密</p>
                </div>
                <div class="card">
                    <p class="cardicon"><i class="inte-notice"></i></p>
                    <p class="cardname">通知提醒</p>
                </div>
                <div class="card">
                    <p class="cardicon"><i class="inte-sole"></i></p>
                    <p class="cardname">独家爆料</p>
                </div>
                <div class="card">
                    <p class="cardicon"><i class="inte-overall"></i></p>
                    <p class="cardname">全面及时</p>
                </div>
            </div>
        </template>
        <template v-else-if="type == 20">
                <div class="focus">
                    <ul>
                        <li>
                            <div class="card">
                                <div class="rader3"></div>
                                <div class="content">
                                    <p class="title">覆盖全球 实时更新</p>
                                    <p class="desc">覆盖全球各大足、篮球赛事，每日实时捕捉最新重要信息</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="card">
                                <div class="rader1"></div>
                                <div class="content">
                                    <p class="title">历史纪录 透视比赛</p>
                                    <p class="desc">搜集当日全球参赛球队、球员各类对比赛有参考价值的历史纪录</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="card">
                                <div class="rader2"></div>
                                <div class="content">
                                    <p class="title">极限数据 规律总结</p>
                                    <p class="desc">精选对比赛有影响的极限数据，包含胜负、大小球、指数等多个维度</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="card">
                                <div class="rader3"></div>
                                <div class="content">
                                    <p class="title">覆盖全球 实时更新</p>
                                    <p class="desc">覆盖全球各大足、篮球赛事，每日实时捕捉最新重要信息</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="card">
                                <div class="rader1"></div>
                                <div class="content">
                                    <p class="title">历史纪录 透视比赛</p>
                                    <p class="desc">搜集当日全球参赛球队、球员各类对比赛有参考价值的历史纪录</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <ol>
                        <li class="current"></li>
                        <li></li>
                        <li></li>
                    </ol>
            </div>
        </template>
        <div :class="{'daily-user-buy': true, 'none': buy_info.total == '0' || isHiscoress()}">
            <span class="user-num">共{{buy_info.total}}人购买</span>
            <template v-if="buy_info.avatar && buy_info.avatar.length > 0">
                <span v-for="(item,index) in buy_info.avatar" :key="index" class="face"><img :src="item" /></span>
            </template>
        </div>
        <div :class="{'daily-buy':true, 'ai':type == 6, 'gofollowservice': (type == 19 || type == 20) && (info.status == 1 || info.status == 2)}">
            <template v-if="info && info.name">
                <template v-if="info.status == 0 || info.status == -1 || info.status == 3">
                    <template v-if="behavior == 1 && info.status == 0">
                        <span class="tags-expired">查看权限派发中，轻点查询按钮可进行刷新</span>
                    </template>
                    <template v-else>
                        <span class="tags-expired">{{info.tags}}</span>
                    </template>
                    <template v-if="(type != 6 || type != 2 || type != 3 || type != 4 || type != 1)">
                        <template v-if=" (isStorepacks() && (getAppVs() == 293))">
                            <div></div>
                        </template>
                        <template v-else-if="behavior == 1 && info.status == 0">
                            <span :class="{'daily-renew':true,'buyinte':type == 19}">查询</span>
                        </template>
                        <template v-else>
                            <span  :class="{'daily-renew':true,'buyinte':type == 19 || type == 20}" >{{dataPrice[type]}}{{isStorepacks()?'元':'嗨币'}}/月</span>
                        </template>
                    </template>
                </template>
                <template v-else-if="info.status == 6">
                    <span class="tags-expired ai">{{info.tags}}</span>
                </template>
                <template v-else>
                    <template v-if="type == 19">
                        <span class="time-expired">有效期至：{{info.end_time && info.end_time.substring(2)}}{{diffDay()}}</span>
                    </template>
                    <template v-else>
                        <span class="time-expired">有效期至：{{info.end_time && info.end_time.substring(0,10)}}{{diffDay()}}</span>
                    </template>
                    <template v-if="!isStorepacks() && (!getAppVs() == 293) && (type != 2 || type != 3 || type != 4 || type != 1)">
                        <span :class="{'daily-renew':true,'isinte':(type == 19 || type == 20) && (info.status == 1 || info.status == 2) && !hiscores,'ishiscores':hiscores}" onClick={self.go_daily_buy.bind(self, type, true)}>续 费</span>
                    </template>
                    <div v-if="(type == 19 || type == 20) && (info.status == 1 || info.status == 2) && !hiscores" class="gotoservicehouse" onClick={self.goFollowServiceHouse.bind(self)}>关注服务号</div>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import mutil from "../../utils/mutil"
import { isStorepack, getAppV, formatNum, isHiscores } from "../../utils/base"
export default {
    name: "hedaer",
    props: ['info', 'type', 'buy_info', 'behavior'],
    data () {
        return {
            dailyMap: mutil.dailyMap,
            // 数据模型价格
            dataPrice: {
                1: 30,
                2: 30,
                3: 98,
                4: 30,
                5: 30,
                18: 198,
                17: 198,
                16: 198,
                15: 298,
                19: 598,
                20: 298,
                21: 198,
                22: 198
            }
        }
    },
    mounted () {
        // eslint-disable-next-line eqeqeq
        if (this.type == 20) {
            this.initRaderCard()
        }
    },
    methods: {
        // 雷达卡片
        initRaderCard () {
            // 1. 获取元素
            var focus = document.querySelector('.focus');
            var ul = focus.children[0];
            var ol = focus.children[1];
            // 获得focus的宽度
            var w = focus.offsetWidth;
            // 2. 利用定时器自动轮播图片
            var index = 0;
            var timer = setInterval(function () {
                index++;
                var translateX = -index * w;
                // 添加动画效果
                ul.style.transition = 'all .3s';
                ul.style.transform = 'translateX(' + translateX + 'px)';
            }, 5000);
            // 等着过渡完成之后，再去判断，监听过渡完成的事件transitionend
            ul.addEventListener('transitionend', function () {
                // 无缝滚动
                if (index >= 3) {
                    index = 0;
                    // 去掉过渡效果，这样让ul快速的跳到目标位置
                    ul.style.transition = 'none';
                    // 利用最新的索引号乘以宽度，继续滚动图片
                    var translateX = -index * w;
                    ul.style.transform = 'translateX(' + translateX + 'px)';
                } else if (index < 0) {
                    index = 2;
                    // 去掉过渡效果，这样让ul快速的跳到目标位置
                    ul.style.transition = 'none';
                    // 利用最新的索引号乘以宽度，继续滚动图片
                    // eslint-disable-next-line no-redeclare
                    var translateX = -index * w;
                    ul.style.transform = 'translateX(' + translateX + 'px)';
                }
                // 3. 小圆点跟随变化
                // 把ol里面li带有current类名的选出来，去掉类名remove
                ol.querySelector('.current').classList.remove('current');
                // 让当前索引号的li加上current类名add
                ol.children[index].classList.add('current');
            });
            // 4. 手指滑动轮播图
            // 触摸元素touchstart：获取手指初始坐标
            var startX = 0;
            var moveX = 0; // 后面会使用这个移动距离，所以要定义为全局变量
            var flag = false; // 用来标志手指是否真的移动，还是只是点击
            ul.addEventListener('touchstart', function (e) {
                startX = e.targetTouches[0].pageX;
                // 手指触摸的时候就停止定时器
                clearInterval(timer);
            });
            // 移动手指touchmove：计算手指的滑动距离，并且移动盒子
            ul.addEventListener('touchmove', function (e) {
                // 计算移动距离
                // e.targetTouches[0]为第一个手指，[1]表示第二个手指
                moveX = e.targetTouches[0].pageX - startX;
                // 移动盒子：盒子原来的位置 + 手指移动的距离
                var translateX = -index * w + moveX;
                // 手指拖动的时候，不需要动画效果，所以要取消过渡效果
                ul.style.transition = 'none';
                ul.style.transform = 'translateX(' + translateX + 'px)';
                flag = true;
                e.preventDefault(); // 组织滚动屏幕的行为
            });
            // 手指离开，根据移动距离去判断是回弹还是播放上一张或者下一张
            ul.addEventListener('touchend', function (e) {
                // 只有手指移动过了，才执行下面的代码
                if (flag) {
                    // （1）如果移动距离大于50像素，则播放上一张或者下一张
                    if (Math.abs(moveX) > 50) {
                        // 如果是右滑就是播放上一张，moveX是正值
                        if (moveX > 0) {
                            index--;
                        } else {
                            // 如果是左滑就是播放下一张，moveX是负值
                            index++;
                        }
                        // 用最新的index乘以宽度
                        var translateX = -index * w;
                        ul.style.transition = 'all .3s';
                        ul.style.transform = 'translateX(' + translateX + 'px)';
                    } else {
                        // （2）如果移动距离小于50像素就回弹
                        // eslint-disable-next-line no-redeclare
                        var translateX = -index * w;
                        ul.style.transition = 'all .1s';
                        ul.style.transform = 'translateX(' + translateX + 'px)';
                    }
                }
                // 手指离开的时候就重新开启定时器
                // 注意：开启定时器之前要先清空之前的定时器，保证当前只有一个定时器在执行
                clearInterval(timer);
                timer = setInterval(function () {
                    index++;
                    var translateX = -index * w;
                    // 添加动画效果
                    ul.style.transition = 'all .3s';
                    ul.style.transform = 'translateX(' + translateX + 'px)';
                }, 5000);
            });
        },
        isHiscoress () {
            return isHiscores()
        },
        isStorepacks () {
            return isStorepack()
        },
        getAppVs () {
            return getAppV()
        },
        diffDay () {
            // eslint-disable-next-line eqeqeq
            if (this.info.status == 2) {
                // 情报时间精确到时分秒
                // eslint-disable-next-line eqeqeq
                if (this.type == 19) {
                    var standtime = this.info.end_time.replace(/-/g, '/');
                    var diffTime = (new Date(standtime).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24;
                    var difftime = formatNum(diffTime, 2) * 1;
                    var difftime2 = Math.ceil(diffTime);
                    if (difftime < 1) {
                        return "";
                    } else {
                        return "(剩余" + difftime2 + "天)";
                    }
                } else {
                    // eslint-disable-next-line no-redeclare
                    var standtime = this.info.end_time.replace(/-/g, '/');
                    // eslint-disable-next-line no-redeclare
                    var diffTime = (new Date(standtime).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24;
                    // eslint-disable-next-line no-redeclare
                    var difftime = Math.ceil(diffTime);
                    return "(剩余" + difftime + "天)";
                }
            }
        }
    }
}
</script>
